import { gql } from '@apollo/client';

export const REQUEST_ACCESS_MUTATION = gql`
  mutation RequestAccess($email: String!, $comment: String) {
    requestAccess(email: $email, comment: $comment) {
      success
      message
      requestId
    }
  }
`;
